require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./gruppo-di-ricerca.json") })
        }
      }, "path---gruppo-di-ricerca");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---gruppo-di-ricerca!./.cache/json/gruppo-di-ricerca.json
// module id = 659
// module chunks = 231608221292675